import type { ReactNode } from 'react';

type BadgeVariant = 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'neutral';

interface GabBadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

export function GabBadge({ children, variant = 'neutral', className = '' }: GabBadgeProps) {
  return <span className={`badge badge-${variant} ${className}`}>{children}</span>;
}
